const Card = ({ children }) => {
	return (
		<div className="rounded-sm border border-stroke bg-white shadow-lg">
			{children}
		</div>
	);
};

export default Card;
